import { Order } from 'components/table/types';
import { DEFAULT_SORT_ORDER } from 'constants/pagination.constants';

export const SYSTEM_MESSAGES_INITIAL_SORT_BY = 'createdAt';
export const SYSTEM_MESSAGES_INITIAL_SORT_ORDER: Order = DEFAULT_SORT_ORDER;

export const SYSTEM_MESSAGES_SORTABLE_COLUMNS = new Set([
	'internalDescription',
	'createdAt',
	'createdBy',
	'startDate',
	'endDate',
	'isLive',
]);

export const mapSystemMessagesSortBy = (sortBy: string) => {
	if (sortBy === 'createdBy') {
		return 'createdByBoUserId';
	}
	return sortBy || SYSTEM_MESSAGES_INITIAL_SORT_BY;
};

export const SystemMessageIconType = {
	OPERATIONAL: 'operational',
	ALERT: 'alert',
	FEATURE: 'feature',
	HOLIDAY: 'holiday',
	POLICY: 'policy',
	GENERAL: 'general',
} as const;
export type SystemMessageIconType = (typeof SystemMessageIconType)[keyof typeof SystemMessageIconType];

export const SystemMessageAudienceType = {
	ALL_USERS: 'all_users',
	NEW_USERS_FIRST_LOGIN: 'new_users_first_login',
	RETURNING_USERS: 'returning_users',
	SPECIFIC_CONTACTS: 'specific_contacts',
	ALL_COMPANY_CONTACTS: 'all_company_contacts',
	SPECIFIC_COMPANY_CONTACTS: 'specific_company_contacts',
} as const;
export type SystemMessageAudienceType = (typeof SystemMessageAudienceType)[keyof typeof SystemMessageAudienceType];

export const StateScope = {
	Global: 'global',
	Company: 'company',
} as const;
export type StateScope = (typeof StateScope)[keyof typeof StateScope];

export const SystemMessageIconLabelKey: Record<SystemMessageIconType, string> = {
	[SystemMessageIconType.OPERATIONAL]: 'page.systemMessages.iconType.operational',
	[SystemMessageIconType.ALERT]: 'page.systemMessages.iconType.alert',
	[SystemMessageIconType.FEATURE]: 'page.systemMessages.iconType.feature',
	[SystemMessageIconType.HOLIDAY]: 'page.systemMessages.iconType.holiday',
	[SystemMessageIconType.POLICY]: 'page.systemMessages.iconType.policy',
	[SystemMessageIconType.GENERAL]: 'page.systemMessages.iconType.general',
};

export const SYSTEM_MESSAGE_RICH_TEXT_TOOLBAR = {
	options: ['inline', 'link'],
	inline: { options: ['bold', 'italic'] },
	link: {
		options: ['link', 'unlink'],
		defaultTargetOption: '_blank',
	},
};

export const SystemMessageAudienceLabelKey: Record<SystemMessageAudienceType, string> = {
	[SystemMessageAudienceType.ALL_USERS]: 'page.systemMessages.audience.all_users',
	[SystemMessageAudienceType.NEW_USERS_FIRST_LOGIN]: 'page.systemMessages.audience.new_users_first_login',
	[SystemMessageAudienceType.RETURNING_USERS]: 'page.systemMessages.audience.returning_users',
	[SystemMessageAudienceType.SPECIFIC_CONTACTS]: 'page.systemMessages.audience.specific_contacts',
	[SystemMessageAudienceType.ALL_COMPANY_CONTACTS]: 'page.systemMessages.audience.all_company_contacts',
	[SystemMessageAudienceType.SPECIFIC_COMPANY_CONTACTS]: 'page.systemMessages.audience.specific_company_contacts',
};

export type SystemMessageAudienceOption = {
	value: SystemMessageAudienceType;
	titleKey: string;
	descKey: string;
};

export const SYSTEM_MESSAGE_DEFAULT_START_TIME = '08:00';
export const SYSTEM_MESSAGE_DEFAULT_END_TIME = '17:30';
export const SYSTEM_MESSAGE_INTERNAL_DESCRIPTION_MAX = 50;
export const SYSTEM_MESSAGE_TITLE_MAX = 60;
export const SYSTEM_MESSAGE_CONTENT_MAX = 400;

export const SYSTEM_MESSAGE_BROADCAST_AUDIENCE_OPTIONS: SystemMessageAudienceOption[] = [
	{
		value: SystemMessageAudienceType.ALL_USERS,
		titleKey: 'page.systemMessages.audience.all_users',
		descKey: 'page.systemMessages.audience.allUsers.desc',
	},
	{
		value: SystemMessageAudienceType.NEW_USERS_FIRST_LOGIN,
		titleKey: 'page.systemMessages.audience.newUsers.title',
		descKey: 'page.systemMessages.audience.newUsers.desc',
	},
	{
		value: SystemMessageAudienceType.RETURNING_USERS,
		titleKey: 'page.systemMessages.audience.returningUsers.title',
		descKey: 'page.systemMessages.audience.returningUsers.desc',
	},
	{
		value: SystemMessageAudienceType.SPECIFIC_CONTACTS,
		titleKey: 'page.systemMessages.audience.specific_contacts',
		descKey: 'page.systemMessages.audience.specificContacts.desc',
	},
];

export const SYSTEM_MESSAGE_COMPANY_AUDIENCE_OPTIONS: SystemMessageAudienceOption[] = [
	{
		value: SystemMessageAudienceType.ALL_COMPANY_CONTACTS,
		titleKey: 'page.systemMessages.audience.all_company_contacts',
		descKey: 'page.systemMessages.audience.allCompanyContacts.desc',
	},
	{
		value: SystemMessageAudienceType.SPECIFIC_COMPANY_CONTACTS,
		titleKey: 'page.systemMessages.audience.specific_company_contacts',
		descKey: 'page.systemMessages.audience.specificCompanyContacts.desc',
	},
];

